import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-16">
      <div className="relative w-full max-w-2xl overflow-hidden rounded-3xl border border-border bg-card px-8 py-14 text-center shadow-sm sm:px-12">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
        <div className="space-y-6">
          <div className="space-y-2">
            <p className="text-sm font-medium uppercase tracking-[0.35em] text-muted-foreground">
              {t('notFound.badge')}
            </p>
            <h1 className="text-7xl font-black tracking-tight text-primary sm:text-8xl lg:text-9xl">
              404
            </h1>
            <h2 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
              {t('notFound.title')}
            </h2>
          </div>

          <p className="mx-auto max-w-lg text-base leading-7 text-muted-foreground sm:text-lg">
            {t('notFound.description')}
          </p>

          <div className="flex justify-center pt-2">
            <Button asChild size="lg" className="px-8">
              <Link to="/">{t('notFound.goHome')}</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
